import { useOpsCache } from 'app/components/ops-cache/useOpsCache'
import { OpsCacheShadcnComponent } from 'app/components/ops-cache/OpsCacheShadcnComponent'

export let handle = {
  breadcrumb: `Redis Cache`,
  title: `Redis Cache`,
}

export default function CachePage() {
  const props = useOpsCache()
  return <OpsCacheShadcnComponent {...props} />
}
